import { ParsedQuery } from 'query-string'

export const getScheduledActionIdFromURL = (
  parsedQueryString: ParsedQuery
): number | null => {
  let scheduledActionParam = parsedQueryString.scheduled_action
  if (!scheduledActionParam) {
    return null
  }
  if (Array.isArray(scheduledActionParam)) {
    scheduledActionParam = scheduledActionParam[0]
  }

  const scheduledActionId = parseInt(scheduledActionParam, 10)

  if (Number.isInteger(scheduledActionId)) {
    return scheduledActionId
  }
  return null
}
